export default {
  产品行业分类: '产品行业分类',
  产品标题: '产品标题',
  产品副标题: '产品副标题',
  产品品牌: '产品品牌',
  产品轮播图: '产品轮播图',
  产品视频: '产品视频',
  产品3D超链接: '产品3D超链接',
  产品规格: '产品规格',
  单价币种: '单价币种',
  服务与承诺: '服务与承诺',
  产品详情: '产品详情',
  // 产品行业分类: '产品行业分类',
  // 产品副标题: '产品副标题',
  // 产品品牌: '产品品牌',
  // 产品轮播图: '产品轮播图',
  // 产品3D超链接: '产品3D超链接',
  // 单价币种: '单价币种',
  // 产品详情: '产品详情',
  产品浏览密码: '产品浏览密码',
  '若产品需要针对竞争对手保密,防止泄露相关产品详细信息,可设置一组4位纯数字的密码,输入正确的密码才可以查看':
    '若产品需要针对竞争对手保密,防止泄露相关产品详细信息,可设置一组4位纯数字的密码,输入正确的密码才可以查看',
  '不设置(任何人都可以查看)': '不设置(任何人都可以查看)',
  '设置(输入密码才可以查看)': '设置(输入密码才可以查看)',
  产品规格与库存: '产品规格与库存',
  '禁止发布涉及政治、色情、暴力、低俗等违法不良信息, 一经发现封号并报警处理!':
    '禁止发布涉及政治、色情、暴力、低俗等违法不良信息, 一经发现封号并报警处理!',
  请输入产品标题: '请输入产品标题',
  请输入产品副标题: '请输入产品副标题',
  请输入产品品牌: '请输入产品品牌',
  请选择行业分类: '请选择行业分类',
  '可描述产品的一些特有功能、亮点等广告用词': '可描述产品的一些特有功能、亮点等广告用词',
  '建议上传正方形图片,大小10M以内': '建议上传正方形图片,大小10M以内',
  '数量限制在10张以内,仅支持JPG/PNG格式,至少上传1张': '数量限制在10张以内,仅支持JPG/PNG格式,至少上传1张',
  点击上传: '点击上传',
  '建议上传时长60秒以内/宽高比为1:1或16:9或3:4,大小不超过100M':
    '建议上传时长60秒以内/宽高比为1:1或16:9或3:4,大小不超过100M',
  点击上传视频: '点击上传视频',
  '若有3D展示,则输入产品3D超链接': '若有3D展示,则输入产品3D超链接',
  '若价格为面议,请在单价填【0】': '若价格为面议,请在单价填【0】',
  '起售数量,指的客户意向采购下单的最低默认数量,具体采购的产品数量建议与客户沟通交流,签订合同':
    '起售数量,指的客户意向采购下单的最低默认数量,具体采购的产品数量建议与客户沟通交流,签订合同',
  '预览图,指的是该产品不同规格的图片,图片建议500*500px,不大于5M':
    '预览图,指的是该产品不同规格的图片,图片建议500*500px,不大于5M',
  '单位,指的是该产品的规格,如台、瓶、张、个、㎡、Kg、g等': '单位,指的是该产品的规格,如台、瓶、张、个、㎡、Kg、g等',
  '单价,指的是该产品规格下,该单位下的销售价格,单价最高可设99999999.99':
    '单价,指的是该产品规格下,该单位下的销售价格,单价最高可设99999999.99',
  '起拍数量,指的是需要达到所设置的起拍数量才可以采购下单': '起拍数量,指的是需要达到所设置的起拍数量才可以采购下单',
  '单价,指的是该产品规格下,该单位下的销售价格': '单价,指的是该产品规格下,该单位下的销售价格',
  请选择币种: '请选择币种',
  '产品规格效果预览（示例）': '产品规格效果预览（示例）',
  'kpaad值换购....': 'kpaad值换购....',
  '200元/罐': '200元/罐',
  '89894罐可售': '89894罐可售',
  '1罐起拍': '1罐起拍',
  添加规格: 'Add Variant',
  预览图: '预览图',
  产品规格名称: '产品规格名称',
  单位: '单位',
  单价: '单价',
  起拍数量: '起拍数量',
  请填写: '请填写',
  删除: '删除',
  是否预售: '是否预售',
  发货时间承诺: '发货时间承诺',
  售后承诺: '售后承诺',
  '上传产品图片时,为了达到更好的展示效果,建议产品详情页图片统一宽度,且图片宽度不超过1000px,若有文字描述,建议排版统一字体与大小':
    '上传产品图片时,为了达到更好的展示效果,建议产品详情页图片统一宽度,且图片宽度不超过1000px,若有文字描述,建议排版统一字体与大小',
  操作: '操作',
  '产品行业分类不能为空！': '产品行业分类不能为空！',
  '产品标题不能为空！': '产品标题不能为空！',
  最多填写50个汉字: '最多填写50个汉字',
  '产品品牌不能为空！': '产品品牌不能为空！',
  '产品轮播图不能为空！': '产品轮播图不能为空！',
  '请选择产品浏览权限！': '请选择产品浏览权限！',
  请输入4位纯数字浏览密码: '请输入4位纯数字浏览密码',
  '最多120个字符,汉字、字符、字母均按1个字符数计算': '最多120个字符,汉字、字符、字母均按1个字符数计算',
  '因参展商的设置,您需要输入产品访问密码才可以浏览': '因参展商的设置,您需要输入产品访问密码才可以浏览',
  '币种不能为空！': '币种不能为空！',
  '产品3D链接最多填写300个汉字！': '产品3D链接最多填写300个汉字！',
  请输入产品详情: '请输入产品详情',
  '您的编辑还未保存, 是否离开?': '您的编辑还未保存, 是否离开?',
  请编辑产品详情: '请编辑产品详情',
  规格预览图: '规格预览图',
  规格名称: '规格名称',
  采购时间: '采购时间',
  请输入规格名称: '请输入规格名称',
  请输入单位: '请输入单位',
  '请输入单价,只可以输入数字': '请输入单价,只可以输入数字',
  请输入起拍数量: '请输入起拍数量',
  请上传预览图: '请上传预览图',
  '规格名称,不可为空,最多可输入30个字符': '规格名称,不可为空,最多可输入30个字符',
  '单位,最多可输入8个字符': '单位,最多可输入8个字符',
  '编码,最多可输入20个字符': '编码,最多可输入20个字符',
  请添加规格: '请添加规格',
  '产品SKU,至少输入一条规格数据': '产品SKU,至少输入一条正确规格数据',
  请填写产品详情介绍: '请填写产品详情介绍',
  '提交产品信息成功,请等待审核': '提交产品信息成功,请等待审核',
  '请删除已上传的视频,再重新添加': '请删除已上传的视频,再重新添加',
  只能上传mp4格式文件: '只能上传mp4格式文件',
}
